module.exports = __webpack_public_path__ + "static/media/S1N4-5.244b0f90.svg";